<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 rotated-labels">
          <chart-card :key='logzio_costs_data' :chart-data="logzio_costs_data.data"
                      :chart-options="logzio_costs_data.options"
                      :responsive-options="logzio_costs_data.responsiveOptions"
                      chart-type="Bar"
                      v-on:clickedBar="on_click($event)"
                      >
            <template slot="header">
              <h4 class="card-title">LogzIO Invoices</h4>
              <p class="card-category">Values in $ (click on the bars for details)</p>
            </template>
            <template slot="footer">
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated monthly / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-6  rotated-labels">
          <chart-card :key='logzio_usage_data' :chart-data="logzio_usage_data.data"
                      :chart-options="logzio_usage_data.options"
                      :responsive-options="logzio_usage_data.responsiveOptions"
                      chart-type="Bar"
                      >
            <template slot="header">
              <h4 class="card-title">Account Breakdown -  {{ this.referenceDate }}</h4>
              <p class="card-category">Values in GB</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <div v-for="(lbl, index) in logzio_usage_data.data.legend">
                  <i class="fa fa-circle" :style='{color: colors[index]}'></i> {{lbl}}
                </div>
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated monthly / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 rotated-labels">
          <chart-card :key='logzio_detailed_usage_data' :chart-data="logzio_detailed_usage_data.data"
                      :chart-options="logzio_detailed_usage_data.options"
                      :responsive-options="logzio_detailed_usage_data.responsiveOptions"
                      chart-type="Bar"
          >
            <template slot="header">
              <h4 class="card-title">Platform Breakdown last 15 days</h4>
              <p class="card-category">Values in GB</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <span v-for="(platform, index) in platforms">
                <i class="fa fa-circle" :style='{color: colors[index]}'></i> {{platform}}</span>
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 rotated-labels">
          <chart-card :key='logzio_detailed_percentage_data' :chart-data="logzio_detailed_percentage_data.data"
                      :chart-options="logzio_detailed_percentage_data.options"
                      :responsive-options="logzio_detailed_percentage_data.responsiveOptions"
                      chart-type="Bar"
          >
            <template slot="header">
              <h4 class="card-title">Platform Breakdown last 15 days</h4>
              <p class="card-category">Percentage</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <span v-for="(platform, index) in platforms">
                <i class="fa fa-circle" :style='{color: colors[index]}'></i> {{platform}}</span>
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'

  import { colors, formatMoney, formatSimple, chart_base } from 'src/globalVariables'
  import { setInterval } from 'timers';


  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData()
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      on_click: function(period){
        this.referenceDate= period.substring(0,4)+'-'+period.substring(4,6)+'-01'
        this.loadData()

      },
      loadData: function(){
        var today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',);
        axios
          .get("http://127.0.0.1:5000/invoices/current-data?vendor_name=LogzIO&st_date=201801&fn_date=201912&access_token=" + this.accessToken)
          .then(response => (this.logzio_invoices = response.data));
        axios
          .get("http://127.0.0.1:5000/logzio/usage?st_date="+this.referenceDate+"&fn_date="+this.referenceDate+"&limit=10&access_token=" + this.accessToken)
          .then(response => (this.logzio_usage = response.data));
        axios
            .get("http://127.0.0.1:5000/logzio/detail?access_token=" + this.accessToken)
            .then(response => (
                this.logzio_detailed_usage = response.data,
                this.loading = false
            ));
        return true
      },
      refresh_logzio: function() {
        var labels = []
        var series1 = []
        if (this.logzio_invoices){
          this.logzio_invoices.forEach(function(v, i){
            labels.push(v['period'])
            series1.push({ "meta": v['period'],"value":parseFloat(v['cost'])})
          })
        }
        this.logzio_costs_data = {
          'data': {
            'labels': labels,
            'series': [series1]
          },
          'options': Object.assign({}, chart_base.options),
          'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
        }
        //override of chart_base
        this.logzio_costs_data.options.seriesBarWidth=40
        this.logzio_costs_data.options.seriesBarDistance = 5
        this.logzio_costs_data.options.tooltip.tooltipOffset= {
          x: 15,
          y: 90
        }
        if (this.logzio_usage.length != undefined){
          var usage_labels = []
          var usage_series = []
          var i = 0;
          this.logzio_usage.forEach(function(v, i){
            usage_labels.push(v['account'])
            usage_series.push([parseFloat(v['cost'])])
          })
        }
        this.logzio_usage_data = {
          'data': {
            'legend': usage_labels,
            'series': usage_series
          },
          'options': Object.assign({}, chart_base.options),
          'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
        }
        //override of chart_base
        this.logzio_usage_data.options.seriesBarWidth=30
        this.logzio_usage_data.options.seriesBarDistance = 50
        this.logzio_usage_data.options.chartPadding= {
            'right': 50,
            'left': 50,
            'bottom': 30,
        },

        this.logzio_usage_data.options.tooltip.tooltipOffset= {
          x: 15,
          y: 90
        }
      },
      refresh_logzio_detail: function () {
          let labels = Object.keys(this.logzio_detailed_usage);

          let series = [];
          let series_percentage = [];

          let data = this.logzio_detailed_usage;
          let platforms = this.platforms;
          var j = 0;

          labels.forEach(function (label, i) {
            Object.keys(data[label]).forEach(function (e) {
              if (platforms.includes(e) != true){
                  platforms.push(e)
              }
            });

            j = 0;

            Object.values(data[label]).forEach(function (v) {
              if (typeof series[j] == 'undefined'){
                  series[j] = []
              }
              if (typeof series_percentage[j] == 'undefined'){
                  series_percentage[j] = []
              }
              series[j][i] = v.usage;
              series_percentage[j][i] = v.percentage;
              j++;
            });
          });


          this.platforms = platforms;


          this.logzio_detailed_usage_data = {
              'data': {
                  'labels': labels,
                  'series': series
              },
              'options': Object.assign({}, chart_base.options),
              'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
          }
          //override of chart_base
          this.logzio_detailed_usage_data.options.seriesBarWidth=50
          this.logzio_detailed_usage_data.options.stackBars= true
          this.logzio_detailed_usage_data.options.tooltip.tooltipOffset= {
            x: 15,
            y: 90
          }

          this.logzio_detailed_percentage_data = {
              'data': {
                  'labels': labels,
                  'series': series_percentage
              },
              'options': Object.assign({}, chart_base.options),
              'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
          }
          //override of chart_base
          this.logzio_detailed_percentage_data.options.seriesBarWidth=50
          this.logzio_detailed_percentage_data.options.stackBars= true
          this.logzio_detailed_percentage_data.options.tooltip.tooltipOffset= {
            x: 15,
            y: 90
          }

      }
    },
    watch: {
      logzio_usage:function(){
        this.refresh_logzio()
      },
      logzio_invoices:function(){
        this.refresh_logzio()
      },
      loading:function () {
        this.refresh_logzio_detail()
      }
    },
    computed: {

    },
    data () {
      return {
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        logzio_invoices:{},
        logzio_usage:{},
        logzio_usage_data: {},
        logzio_costs_data:{},
        logzio_detailed_usage: {},
        logzio_detailed_percentage: {},
        logzio_detailed_usage_data: {},
        logzio_detailed_percentage_data: {},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        referenceDate: '2019-12-01',
        platforms : [],
        loading: true
      }
    }
  }
</script>
<style>

</style>
